import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const useOffline = () => {
  const [off, setOff] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  useEffect(() => {
    const on = () => setOff(false), offh = () => setOff(true);
    window.addEventListener("online", on); window.addEventListener("offline", offh);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", offh); };
  }, []);
  return off;
};

/* Shown on Home / timeline while the phone has no internet: we keep showing the last saved results. */
export const OfflineHint = ({ offline, at, ta }) => {
  if (!offline) return null;
  const when = at ? new Date(at).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) : null;
  return (
    <div className="rounded-xl bg-slate-800 text-white px-3 py-2 text-[11px] flex items-center gap-2" data-testid="home-offline-hint">
      <WifiOff className="w-3.5 h-3.5 text-amber-300 shrink-0" />
      <span>{ta ? "Offline — கடைசியாக சேமித்த results & timeline காட்டப்படுகிறது" : "Offline — showing your last saved results & timeline"}{when ? ` · ${when}` : ""}. {ta ? "Booking-க்கு internet ON பண்ணுங்க." : "Turn internet on to book."}</span>
    </div>
  );
};
